class ModuleSidebarBirthday {
  constructor() {
    this._init();
  }

  _init() {
    const sidebar_birthday_close = document.querySelector(
      '[data-close-sidebar-birthday]'
    );

    if (sidebar_birthday_close) {
      sidebar_birthday_close.addEventListener(
        'click',
        this._hideSidebar.bind(this)
      );
    }
  }

  _hideSidebar() {
    console.log('Close sidebar birthday');

    const sidebar_birthday = document.getElementById('sidebar-birthday');
    if (sidebar_birthday && sidebar_birthday.classList.contains('open')) {
      sidebar_birthday.classList.remove('open');
      document.body.classList.remove('sidebar-open');
    }
  }
}

export const moduleSidebarBirthday = new ModuleSidebarBirthday();
